






import Vue from 'vue';
import { Component, Prop } from 'vue-property-decorator';
import { ChapterItem } from '@/app/shared/models/reports/ChapterItem';
import _debounce from 'lodash.debounce';

@Component({
  components: {},
})
export default class ImpactChapterItem extends Vue {
  @Prop() item: ChapterItem;
}
